export default __webpack_public_path__ + "static/media/piggiImageWithShield.c7b099a1.png";